import { Chip } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface FaqStatusBadgeProps {
    isActive: boolean
}

export const FaqStatusBadge = ({ isActive }: FaqStatusBadgeProps) => {
    const { t } = useTranslation()
    
    return (
        <Chip
            label={isActive ? t('common.active') : t('common.inactive')}
            color={isActive ? 'success' : 'default'}
            size="small"
            variant="outlined"
        />
    )
}
